import React from 'react';
import { FlowerIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
type PriceSectionProps = {
  onCTA: () => void;
};
const badges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Una sola vez'
}];
export function PriceSection({
  onCTA
}: PriceSectionProps) {
  return <section id="precio" className="w-full scroll-mt-20 bg-crema py-20 sm:py-28" data-id="element-161" data-mp="2vhyep1g3ygcj">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-162" data-mp="2qkevro8gtfe9">
        <Reveal className="text-center" data-id="element-163" data-mp="2mibfmmaupmmn">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-164" data-mp="2mjczng9uhjgi">
            Invierte en ti hoy
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-165" data-mp="kqovn4pdmrzo">
            Menos de lo que gastas en una salida, por 30 días que pueden cambiar
            cómo te sientes en tu cuerpo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-166" data-mp="1rhfewjq1oe6w">
          <div className="mt-10 overflow-hidden rounded-[2rem] border border-nude bg-white p-8 text-center shadow-xl shadow-rosa/15 sm:p-12" data-id="element-167" data-mp="1riqhwhbo1hwy">
            <span className="mb-8 inline-flex items-center gap-2 rounded-full bg-rosa/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-rosa-dark" data-id="element-168" data-mp="1dk0n58cbjubr">
              <FlowerIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-169" data-mp="25aetmji064de" />
              Oferta de lanzamiento
            </span>

            <CountdownTimer data-id="element-170" data-mp="2a7exqovakx1v" />

            <div className="mt-6 flex flex-wrap items-end justify-center gap-x-3 gap-y-2" data-id="element-171" data-mp="1wgs43b4e1xcn">
              <span className="mb-1 flex h-16 w-16 shrink-0 -rotate-12 flex-col items-center justify-center rounded-full border border-rosa/40 bg-rosa/15 text-rosa-dark" data-id="element-172" data-mp="20idm1avs51tp">
                <span className="font-serif text-xl font-semibold leading-none" data-id="element-173" data-mp="2o6oh1xeso7a2">
                  65%
                </span>
                <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.12em]" data-id="element-174" data-mp="32uog1mvgl61r">
                  Dcto
                </span>
              </span>
              <span className="font-serif text-2xl text-tinta/40 line-through" data-id="element-175" data-mp="2ytkzsz9i1800">
                $47 USD
              </span>
              <span className="font-serif text-6xl font-semibold text-rosa-dark sm:text-7xl" data-id="element-176" data-mp="2tvtamd08nzzi">
                $17
              </span>
              <span className="pb-2 text-lg font-medium text-tinta/60" data-id="element-177" data-mp="2jwc8u6o3y68t">
                USD
              </span>
            </div>
            <p className="glow-pulse mt-2 text-sm font-medium tracking-wide text-tinta/60" data-id="element-178" data-mp="2f4anzwcvj776">
              Un solo pago · Acceso de por vida
            </p>

            <CTAButton id="comenzar-transformacion" onClick={onCTA} icon={FlowerIcon} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-179" data-mp="264nwq3duzhru">
              Comenzar mi transformación
            </CTAButton>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-tinta/70" data-id="element-180" data-mp="1w8kku5t7g4rp">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5" data-id="element-181" data-mp="1r02ytfjtoxvp">
                  <b.icon className="h-4 w-4 text-dorado" strokeWidth={1.8} data-id="element-182" data-mp="1vyebdy1i5mhm" />
                  {b.label}
                </span>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}